var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"lbErrorModal\" ng-class=\"{ 'lbErrorModal-warning': vm.warnLevel === 'warning' }\">\n<header class=\"lbModal_header\" ng-switch=\"vm.warnLevel\">\n<button class=\"lbModal_close\" ng-click=\"vm.close()\"><span>close</span></button>\n<h2 ng-switch-when=\"info\">\n<i class=\"ico-info-circle\"></i> {{ ::vm.errorMessage }}\n</h2>\n<h2 ng-switch-default>\n<i class=\"ico-fontawesome-webfont\"></i> {{ ::vm.errorMessage }}\n</h2>\n</header>\n<div class=\"lbModal_body\">\n<p>{{ ::vm.errorDesc }}</p>\n<p class=\"modal_note\" ng-if=\"vm.instructions\">\n{{ ::vm.instructions }}\n</p>\n</div>\n<div class=\"lbModal_actions\">\n<button class=\"button-primary\" ng-click=\"vm.close()\">OK</button>\n</div>\n</div>\n";
var id1="components/lbErrorModal/lbErrorModal.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbErrorModal/lbErrorModal.html
// module id = 1041
// module chunks = 2